<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'program', params: {} }">
            Program
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'programView', params: {} }">
              View Program
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Program
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="program.name">
            <td max-width="35%" class="text-subtitle-1">Name:</td>
            <td>{{ program.name }}</td>
          </tr>
          
          <tr v-if="program.description">
            <td max-width="35%" class="text-subtitle-1">Description:</td>
            <td>{{ program.description }}</td>
          </tr>
          
          <tr v-if="program.standardRate">
            <td max-width="35%" class="text-subtitle-1">Standard Rate:</td>
            <td>{{ program.standardRate }}</td>
          </tr>
          
          <tr v-if="program.payTerm">
            <td max-width="35%" class="text-subtitle-1">Payment Terms:</td>
            <td>{{ program.payTerm }}</td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getProgram } from "@/services/program";
    

    export default {
      data() {
        return {
            id: '',
            program: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "programEdit", params: { id: id }});
        },
        setInstance() {
          this.setDependencies().then( () => {
            getProgram(this.id)
            .then((response) => {
              this.program = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading program");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          return null;
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstance();
        this.$emit("showParent", false);
      }
    }
    </script>
    